import type { JSX } from 'react';
import type { WireConversationSummary } from '@logistics/contracts';
import { cn } from '@/lib/utils';
import { Modal } from '../shell/modal';
import { button } from '../shell/look';

/** Deleting a conversation cannot be undone, so it is asked once more. */
export function ConfirmDelete({
  conversation,
  onCancel,
  onConfirm,
}: {
  conversation: WireConversationSummary;
  onCancel: () => void;
  onConfirm: () => void;
}): JSX.Element {
  return (
    <Modal eyebrow="CHAT" title="Delete this conversation?" onClose={onCancel}>
      <div className="flex flex-col gap-4 px-7 py-6">
        <p className="text-mute m-0 text-[13.5px] leading-[1.55] [overflow-wrap:anywhere]">
          “{conversation.title}” and every answer in it are removed for good.
        </p>
        <div className="flex justify-end gap-2.5">
          <button type="button" onClick={onCancel} className={button.outline}>
            Cancel
          </button>
          <button
            type="button"
            onClick={onConfirm}
            className={cn(button.primary, 'bg-bad text-white')}
          >
            Delete
          </button>
        </div>
      </div>
    </Modal>
  );
}
